/**
 * Centralized test mode flag.
 * This is true only when Playwright starts the app with
 * REACT_APP_PLAYWRIGHT_TEST=true.
 */
export const isPlaywrightTest =
  process.env.REACT_APP_PLAYWRIGHT_TEST === 'true';

/**
 * Synthetic user injected in Playwright test mode to bypass Okta authentication.
 * Update this object if the test environment requires different user details.
 */
export const playwrightTestUser = {
  name: 'Test User',
  unique_name: 'Test User',
  oid: 'testuser',
};
